import React from 'react';
import { ErrorLayout } from '@components-shared/ErrorLayout';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
// @ts-ignore: remove after translating into typescript
import { getAppInsights } from 'applicationInsights/TelemetryService';
import { IError } from '../index';
import './styles.scss';

const SpareComponent: React.FC<{ error: IError | null }> = ({ error }) => {
  const message = error ? error.message : 'Error';
  const appInsightsError = new Error(message);

  if (error) {
    appInsightsError.stack = error.stack;
  }

  try {
    const appInsights = getAppInsights();

    if (appInsights) {
      appInsights.trackException({
        error: appInsightsError,
        severityLevel: SeverityLevel.Critical,
      });
    }
  } catch (e) {
    console.error('appInsights error');
  }

  return <ErrorLayout message={message} />;
};

export default SpareComponent;
